export const TM = ({ className = "" }) => (
  <sup className={`tm ${className}`} aria-label="trademark">™</sup>
);

export const withTM = (html) => html.replace(/TruCitizen™/g, 'TruCitizen<sup class="tm">™</sup>');
